<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
      <v-expansion-panel-header>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" PROGRAM>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-chip color="secondary" 
                    label x-small style="text-transform:uppercase;" 
                    v-if="r.program_name && r.program_name.slug"
                  >{{i18n[r.program_name.slug]}}</v-chip>
                  <v-progress-circular indeterminate v-if="!r.program_name || !r.program_name.slug" color="primary"></v-progress-circular>
                </span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.program_name && r.program_name.slug"
                >{{i18n[r.program_name.slug]}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`" EMAIL>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span class="px-1" v-bind="attrs" v-on="on">{{r.email}}</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-if="r.multiple" dark v-bind="attrs" v-on="on" size="14" color="red">mediation</v-icon>
                  </template>
                  <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                    <v-icon dark size="18">mediation</v-icon> {{i18n.duplicate}}
                  </span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="error" size="14" v-if="r.match_sub && r.match_sub.bounced" v-bind="attrs" v-on="on">
                      cancel_schedule_send
                    </v-icon>
                  </template>
                  <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                    Wrong Email
                  </span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="grey" size="14" v-if="r.email_meta && r.email_meta.delivered && !r.email_meta.open" v-bind="attrs" v-on="on">
                      done_all
                    </v-icon>
                    <v-icon color="success" size="14" v-if="r.email_meta && r.email_meta.delivered && r.email_meta.open" v-bind="attrs" v-on="on">
                      done_all
                    </v-icon>
                  </template>
                  <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                    <span v-if="r.email_meta && r.email_meta.delivered && !r.email_meta.open">Delivered</span>
                    <span v-if="r.email_meta && r.email_meta.delivered && r.email_meta.open">Opened</span>
                  </span>
                </v-tooltip>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.name}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.source}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`">{{r.phone}}</div>
                <div :class="`${arabic?'arFont':'enFont'}`" style="text-transform:uppercase;"
                  v-if="r.program_name && r.program_name.slug"
                >{{i18n[r.program_name.slug]}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-light`" NAME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-if="r.user_name" class="font-size:10px;">{{r.user_name.name.slice(0, 12)}}..</span>
              </template>
              <div class="text-center">
                <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.user_name">{{r.user_name.name}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`" DATETIME>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" v-if="r.created_at">
                  <v-icon size="10">date_range</v-icon>
                  {{r.created_at.split('T')[0]}}
                </span>
              </template>
              <div class="text-center">
                <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{getFormat(r.created_at)}}</div>
              </div>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`" EDITBUTTON>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" 
                  :disabled="r.lock" v-if="!match"
                  x-small @click.stop="edit(r)">
                  <v-icon left size="12">create</v-icon>
                  {{i18n.editIconTooltip}}
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                {{i18n.editIconTooltip}}
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 text-center`" OPENCOLOR>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-avatar v-bind="attrs" v-on="on" size="12" :color="getColor(r.match_sub ? r.match_sub : null)">
                  <v-icon dark>icon</v-icon>
                </v-avatar>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`"
                v-if="r.match_sub"
              >
                {{r.match_sub && r.match_sub.open ? 'Open' : r.match_sub && r.match_sub.bounced ? 'Bounced' : r.match_sub &&  r.match_sub.unsubscribed ? 'Unsubscribed' : 'Unknown'}}
              </span>
            </v-tooltip>
            
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-divider class="pb-3"></v-divider>
        <v-row class="pa-0 align-center">
          <v-col cols="6" md="3" v-for="(key, det) in resourceKeys.map(x=>x.fetched)" :key="'details'+det"
            :class="`${arabic?'arFont':'enFont'} pa-0`">
            <div style="font-size:9px;font-weight:700;text-transform:uppercase;">{{i18n[key]}}</div>
            <div style="font-size:12px;"
              v-if="!key.includes('_name')"
              v-clipboard:copy="r[key]"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{r[key]}}
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="error" size="14" v-if="key == 'email' && r.match_sub && r.match_sub.bounced">cancel_schedule_send</v-icon>
                </template>
                <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                  Wrong Email
                </span>
              </v-tooltip>
            </div>
            <div style="font-size:12px;"
              v-if="key.includes('_name') && r[key]"
              v-clipboard:copy="i18n[r[key].slug]"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
            >
              {{ r[key].slug ? i18n[r[key].slug] : r[key].name }}
            </div>
          </v-col>
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0 pt-2 text-center`">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" 
                  :disabled="r.lock"
                  x-small @click.stop="edit(r)">
                  <v-icon left size="12">create</v-icon>
                  {{i18n.editIconTooltip}}
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                {{i18n.editIconTooltip}}
              </span>
            </v-tooltip>
          </v-col>
          
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0 pt-2 text-center`" v-if="r.multiple && false">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" 
                  :disabled="r.lock"
                  x-small @click.stop="edit(r)">
                  <v-icon dark left size="12">mediation</v-icon> 
                  {{i18n.duplicate}}
                </v-btn>
              </template>
              <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                {{i18n.duplicate}}
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['resourceSettings', 'resource' , 'resourceKeys', 'match'],
  methods:{
    getColor(sub) {
      if(!sub) {
        return 'secondary'
      } else 
      if(sub && sub.open) {
        return 'success'
      } else 
      if(sub && sub.bounced) {
        return 'error'
      } else
      if(sub && sub.unsubscribed) {
        return "#FFC107"
      } else if(sub) {
        return 'primary'
      }
    },
    edit(r) {
      this.$emit('editLead', r)
    },
    getFormat(d){
      return format(d)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('copyS', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('copyF', { value, event })
    },
  },
  computed:{
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },

  }
}
</script>

<style>

</style>